<template>
  <table class="ks-is-fullwidth">
    <template v-for="(item, index) in items">
      <template>
        <tr :key="'dispatch' + index">
          <td colspan="100">
            <kst-value class="print-thermal-size" field="DispatchID" 
              :data="item" :catalog="PurItemCatalog"
            />
          </td>
        </tr>
      </template>

      <template>
        <tr :key="'detail' + index">
          <td class="is-flex">
            <kst-value class="print-thermal-size ks-space-right" field="Quantity" 
              :data="item" :catalog="PurItemCatalog"
            />
            <div class="ks-space-right">x</div>
            <kst-value class="print-thermal-size" field="BuyPrice" 
              :data="item" :catalog="PurItemCatalog"
            />
          </td>
          <td class="has-text-right">
            <kst-value class="print-thermal-size" field="ExpenseAmount" 
              :data="item" :catalog="PurItemCatalog"
            />
          </td>
        </tr>
      </template>
    </template>
  </table>
</template>

<script>
import PurItemCatalog from "../PurItemCatalog.js";

export default {
  props: {
    items: Array
  },
  data: () => ({
    PurItemCatalog: PurItemCatalog
  })
}
</script>